/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

import { stream } from '@/services/stream';
import { KahuEvent, KahuEventHandler, KahuRequestBody } from 'types/kahu';

export const streamKahuMessages = async (
  body: KahuRequestBody,
  onEvent: KahuEventHandler,
  abortSignal: AbortSignal
): Promise<void> => {
  const response = await stream.post(
    { endpoint: 'ask_agent/stream' },
    body,
    false,
    false,
    true,
    abortSignal
  );

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error?.message || response.statusText);
  }

  const reader = response.body?.getReader();
  if (!reader) throw new Error('Response body is not readable');

  const decoder = new TextDecoder();
  let buffer = '';

  try {
    let done = false;
    while (!done) {
      const result = await reader.read();
      done = result.done;
      if (done) break;

      buffer += decoder.decode(result.value, { stream: true });
      const lines = buffer.split('\n');
      buffer = lines.pop() ?? '';

      for (const line of lines) {
        if (!line.startsWith('data: ')) continue;
        try {
          const event: KahuEvent = JSON.parse(line.slice(6));
          onEvent(event);
        } catch {
          continue;
        }
      }
    }
  } finally {
    reader.releaseLock();
  }
};
